// Sidebar modules Platform Admin can switch on/off per clinic. Keys must
// match medipro-backend/constants/modules.js; stored under
// settings.features.modules, where missing/true means on. Dashboard,
// Settings and User Master aren't listed — those are never switched off.
export const MODULE_GROUPS = [
  {
    label: "Care Desk",
    modules: [
      { key: "opd", label: "OPD Booking" },
      { key: "appointments", label: "Appointments" },
      { key: "leads", label: "Lead Inbox (AI chatbot)" },
      { key: "doctor_attendance", label: "Doctor Attendance" },
      { key: "lab_orders", label: "Diagnostic Booking (Lab Orders)" },
      { key: "diagnostics", label: "Diagnostic departments (technician worklists)" },
      { key: "prescriptions", label: "Prescriptions" },
      { key: "messages", label: "Messages" },
      { key: "activity", label: "Activity Log" },
    ],
  },
  {
    label: "Doctors",
    modules: [{ key: "doctor_portal", label: "Doctor portal (My Practice)" }],
  },
  {
    label: "Finance",
    modules: [
      { key: "billing", label: "Billing & Invoices" },
      { key: "stats", label: "Stats" },
    ],
  },
  {
    label: "Master",
    modules: [
      { key: "doctors", label: "Doctors" },
      { key: "patients", label: "Patients" },
      { key: "lab_catalog", label: "Test Catalogue" },
      { key: "labs", label: "Partner Labs" },
      { key: "diagnostic_departments", label: "Diagnostic Departments" },
      { key: "medicines", label: "Medicines" },
      { key: "clinical_terms", label: "Diagnoses & Symptoms" },
      { key: "departments", label: "OPD Departments" },
    ],
  },
];

export const isModuleEnabled = (settings, key) => !key || settings?.features?.modules?.[key] !== false;
